import { Injectable } from "@angular/core";
import { RequestsService } from "./requests.service";
import { getConnection, getFromLocal, hideSpinner, setOnLocal, showSpinner } from "./functions.service";
import { HelpersService } from "./helpers.service";
import { isEmpty, isNotEmpty, isNotEmptyObject } from "class-validator";
import { environment } from "src/environments/environment";
import { EndpointsService } from "src/app/modules/admin/modules/superadmin/config/services/endpoints.service";
import { QueriesService } from "./queries.service";
import { CausalDet } from "src/app/modules/shared/imports/models/causal_det.model";
import { SerProperty } from "src/app/modules/admin/modules/superadmin/config/models/property.model";
import { RolesService } from "src/app/modules/admin/modules/superadmin/modulos/services/roles.service";

@Injectable({
    providedIn: 'root',
})
export class GeneralsService {

    constructor(private helpers: HelpersService, private requestsService: RequestsService, private endpointsService: EndpointsService, private queriesService: QueriesService, private rolesService: RolesService) { }

    /**
     * Gets the endpoints from localStorage (secureStorage)
     * @returns array or object
     */
    async getEndpoints(reload: boolean = false): Promise<any> {
        let endpoints = getFromLocal(environment.LOCAL_ENDPOINTS);
        if (isEmpty(endpoints) || !isNotEmptyObject(endpoints) || reload) {
            showSpinner()
            const result = await this.endpointsService.findAll({ estado: "A" })
            hideSpinner()
            if (result.success) {
                setOnLocal(environment.LOCAL_ENDPOINTS, result.data)
                return result.data
            } else {
                this.helpers.notifications.errorMessage("No se pudieron cargar los endpoints")
                return {}
            }
        } else {
            return endpoints
        }
    }

    async getRoles(usuario_aplicativo: string, reload: boolean = false): Promise<any> {
        let roles = getFromLocal(environment.LOCAL_ROLES);
        if (isEmpty(roles) || !isNotEmptyObject(roles) || reload) {
            showSpinner()
            const result = await this.rolesService.findAllByUser(usuario_aplicativo)
            hideSpinner()
            if (result.success) {
                setOnLocal(environment.LOCAL_ROLES, result.data)
                return result.data
            } else {
                this.helpers.notifications.errorMessage("No se pudieron cargar los roles")
                return {}
            }
        } else {
            return roles
        }
    }

    existeRol(codigo_rol: string): boolean {
        let roles = getFromLocal(environment.LOCAL_ROLES);
        if(Array.isArray(roles)) {
            const existe = roles.filter(r => r.codigo == codigo_rol);
            return existe.length > 0;
        }
        return false;
    }


    async getEndpoint(clave: string): Promise<string> {
        if (isNotEmpty(clave)) {
            const endpoints = await this.getEndpoints()
            if (isNotEmpty(endpoints) && isNotEmptyObject(endpoints)) {
                const endpoint = endpoints[clave]
                if (endpoint) {
                    return endpoint
                } else {
                    showSpinner()
                    const result = await this.endpointsService.findOne(clave, { estado: "A" })
                    hideSpinner()
                    if (result.success && result.data) {
                        endpoints[result.data.clave] = result.data.valor
                        setOnLocal(environment.LOCAL_ENDPOINTS, endpoints)
                        return result.data.valor
                    } else {
                        throw new Error("No se encuentra el endpoint con esta clave: " + clave);
                    }
                }
            } else {
                throw new Error("No se pudieron cargar los endpoints");
            }
        } else {
            throw new Error("Especifique una clave/nombre de endpoint");
        }
    }

    async getGeneralsByFile(archivo: string = "generales.json") {
        const generals = await this.requestsService.makeRequest(environment.domain, environment.urls.generals, { archivo })
        if (generals.success) {
            return generals.data
        }
        throw new Error("No se pudieron obtener los datos de generals");
    }

    async getGeneralsJSON(reload: boolean = false) {
        try {
            let generals = getFromLocal(environment.LOCAL_GENERALS);
            if (isEmpty(generals) && !isNotEmptyObject(generals) || reload) {
                generals = await this.getGeneralsByFile()
                if (isNotEmptyObject(generals)) {
                    setOnLocal(environment.LOCAL_GENERALS, generals)
                }
            }
            return generals
        } catch (error) {
            return null
        }
    }

    async getCausalDet(cod_causal: string) {
        const result = await this.queriesService.query(`Select E.Cod_Tipo, D.*
        From Causal_Enc E, Causal_Det D
        Where E.C_EMP = D.C_EMP
        And E.COD_TIPO = D.COD_TIPO
        And E.C_Emp = '${getConnection()}'
        And E.Cod_Tipo = '${cod_causal}'
        And E.Estado = 'A'
        And D.EST = 'A'
        Order By D.Tipo, D.DES`)
            .execute()
        return result
    }

    async getProperty(name: string): Promise<SerProperty | undefined> {
        let properties = this.getProperties();
        if (properties && Array.isArray(properties)) {
            const find = properties.find((prop) => { return prop.key == name })
            if (find) {
                return find
            }
        }
        const result = await this.queriesService.table("SER_PROPERTIES").select("key", "valor").where({ key: name }).execute()
        if (result.success && result.data && Array.isArray(result.data) && result.data[0]) {
            this.addProperty(result.data[0])
            return result.data[0]
        }
        throw new Error(`No se encontró el property '${name}'`);
    }
    async getMunicipios(c_dpto: string) {
        const result = await this.queriesService.query(`SELECT * FROM municipio WHERE c_emp = '${getConnection()}' AND estado = 'A' AND c_dpto = '${c_dpto}' order by nombre`).execute()
        return result
    }

    async getDepartamentos() {
        const result = await this.queriesService.query(`SELECT * FROM departamento WHERE c_emp = '${getConnection()}' AND estado = 'A' order by nombre`).execute()
        return result
    }

    private getProperties(): SerProperty[] | undefined {
        return getFromLocal(environment.LOCAL_PROPERTIES)
    }

    private addProperty(property: any) {
        let result = this.getProperties();
        if (result && Array.isArray(result)) {
            const find = result.find((prop) => { return property.key == prop.key })
            if (!find) {
                result.push(property)
            }

        } else {
            result = [property]
        }
        setOnLocal(environment.LOCAL_PROPERTIES, result)
    }
}
